import { render, staticRenderFns } from "./provision-team.vue?vue&type=template&id=4fd038d5&scoped=true&"
import script from "./provision-team.vue?vue&type=script&lang=js&"
export * from "./provision-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd038d5",
  null
  
)

export default component.exports